<template>
	<div id="dorm_top" class="w-100 d-flex flex-nowrap flex-between" style="margin: 0.3rem;">
		<div class="small_block">
			<div class="top_rotate">
				<div class="bg_rotate">
					<img width="100%" height="100%" src="../../assets/img/top_icon.png">
				</div>
				<div class="rotate_imgicon">
					<img width="100%" height="100%" src="../../assets/img/duty_icon.png">
				</div>
			</div>
			<div class="block_txt">
				<div class="block_num yellow">{{ qjCount }}</div>
				<div class="title-item">今日请假人数</div>
			</div>
		</div>
		<div class="small_block">
			<div class="top_rotate">
				<div class="bg_rotate">
					<img width="100%" height="100%" src="../../assets/img/top_icon.png">
				</div>
				<div class="rotate_imgicon">
					<img width="100%" height="100%" src="../../assets/img/bed_icon.png">
				</div>
			</div>
			<div class="block_txt">
				<div class="block_num green">{{ zsCount }}</div>
				<div class="title-item">今日住宿人数</div>
			</div>
		</div>
		<div class="small_block">
			<div class="top_rotate">
				<div class="bg_rotate">
					<img width="100%" height="100%" src="../../assets/img/top_icon.png">
				</div>
				<div class="rotate_imgicon">
					<img width="100%" height="100%" src="../../assets/img/warning_icon.png">
				</div>
			</div>
			<div class="block_txt">
				<div class="block_num red">{{ wgCount }}</div>
				<div class="title-item">昨日未归人数</div>
			</div>
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
export default {
	data() {
		return {
			qjCount: 0,
			zsCount: 0,
			wgCount: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {
		initData() {
			let _this = this;
			this.$http.get("/dataView/dorm/todayCensus?orgId=" + orgId + "&buildIds=" + buildIds).then(res => {
				if (res.data.code === 200) {
					_this.qjCount = res.data.result.qj_count;
					_this.zsCount = res.data.result.zs_count;
					_this.wgCount = res.data.result.wg_count;
				}
			});
		}
	}
};
</script>

<style lang="scss">
#dorm_top {

	.small_block {
		width: 33%;
	}

	.small_block dv-border-box-8 {
		width: 100%
	}

	.block_txt {
		font-size: 0.25rem;
		color: #fff;
		margin-top: 0.12rem;
		float: left;
		margin-left: 0.2rem;
	}

	.block_txt .block_num {
		font-size: 0.5rem;
		font-weight: bold;
	}

	.top_rotate {
		position: relative;
		float: left;
		width: 1.2rem;
		height: 1.2rem;
	}

	.rotate_bgicon {
		width: 1.2rem;
		height: 1.2rem;
		position: relative;
	}

	.bg_rotate {
		width: 1.2rem;
		height: 1.2rem;
		position: absolute;
		top: 0;
		left: 0
	}

	.bg_rotate img {
		animation: rotate01 2s linear infinite;
	}

	@keyframes rotate01 {

		/* css事件 animation: rotate01 2s linear infinite;*/
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);

			/* 可配置跳动方向 */
		}
	}

	.rotate_imgicon {
		width: 0.5rem;
		position: absolute;
		top: 0.33rem;
		left: 0.35rem
	}
}
</style>
